import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectorRef, inject, DestroyRef, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MaintenanceOwnerService } from '../maintenance-owner/maintenance-owner.service';

import { safeJsonInput } from '../../../shared/_utils/safe-json-input';
@Component({
    selector: 'gtw-maintenance-owner-delete',
    templateUrl: './maintenance-owner-delete.component.html',
    styleUrls: ['./maintenance-owner-delete.component.scss'],
    standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class MaintenanceOwnerDeleteComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  @Output('request-grid-update') requestGridUpdate = new EventEmitter<any>();

  // STANDARD COMPONENT PROPERTIES
  currentTabName = "Form Entry";
  minimise = false;
  isSaveClicked = false;
  crudLoading = false;
  showFormLoader = false;

  // Component specific properties
  modalTitle = "Delete Maintenance Owner";
  isDelete = true;

  // Data properties
  rowData: any = {};
  globalService: any = {};
  GENERAL_CONFIG: any = {};
  USER_SETTINGS: any = {};
  colData: any = {};
  gridData: any = {};

  // Entity data properties
  entityList: any[] = [];
  leId: string = '';
  cdr_no: string = '';
  leType: string = '';

  // Delete specific properties
  ho_leid: string = '';
  ho_cdr_no: string = '';
  ho_combination_key: string = '';
  logged_in_user: string = '';

  constructor(
    private _snackBar: MatSnackBar,
    private maintenanceOwnerService: MaintenanceOwnerService,
    private cdr: ChangeDetectorRef
  ) {}

  @Input('base-urls')
  set _base_urls(baseUrls: string) {
    try {
      let urls = safeJsonInput<any>(baseUrls, null, 'maintenance-owner-delete.parse1');
      if (Object.keys(urls).length > 0) {
        // Handle base URLs if needed
      }
    } catch (e) {
      console.log("Base URLs input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('header-data')
  set _header_data(headerData: string) {
    try {
      let header = safeJsonInput<any>(headerData, null, 'maintenance-owner-delete.parse2');
      if (Object.keys(header).length > 0) {
        this.globalService = header.globalParams || {};
        this.USER_SETTINGS = header.userSettingsData || {};
        this.GENERAL_CONFIG = header.generalConfigData || {};
        this.logged_in_user = this.USER_SETTINGS?.user?.sso_id || '';
        this.init();
      }
    } catch (e) {
      console.log("Header data input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('row-data')
  set _row_data(rowData: string) {
    try {
      let data = safeJsonInput<any>(rowData, null, 'maintenance-owner-delete.parse3');
      if (Object.keys(data).length > 0) {
        this.rowData = data;
        this.processRowData();
        this.init();
      }
    } catch (e) {
      console.log("Row data input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('col-data')
  set _col_data(colData: string) {
    try {
      let data = safeJsonInput<any>(colData, null, 'maintenance-owner-delete.parse4');
      if (Object.keys(data).length > 0) {
        this.colData = data;
      }
    } catch (e) {
      console.log("Col data input not yet stable. Still waiting to get resolved.");
    }
  }

  @Input('grid-data')
  set _grid_data(gridData: string) {
    try {
      let data = safeJsonInput<any>(gridData, null, 'maintenance-owner-delete.parse5');
      if (data != null) {
        this.gridData = data;
      }
    } catch (e) {
      console.log("Grid data input not yet stable. Still waiting to get resolved.");
    }
  }

  ngOnInit(): void {
    this.init();
  }

  init() {
    try {
      if (this.rowData && Object.keys(this.rowData).length > 0) {
        this.setupEntityData();
        this.processRowData();
      }
    } catch (e) {
      console.error('Error in MaintenanceOwnerDelete init:', e);
    }
  }

  private setupEntityData() {
    // 🔴 CRITICAL: Use REAL data from rowData - NO TEST_ values!
    this.leId = this.rowData.LEID || '';
    this.cdr_no = this.rowData.MARS || '';
    this.leType = this.rowData.LE_TYPE || '';

    // 🔴 MANDATORY ORDER: Tax Year, LEID, LE Name
    this.entityList = [
      { key: "Tax Year", value: this.rowData.TAX_YEAR || '' },
      { key: "LEID", value: this.rowData.LEID || '' },
      { key: "LE Name", value: this.rowData.LE_NAME || '' }
    ];
  }

  private processRowData() {
    if (this.rowData) {
      this.ho_leid = this.rowData.HO_LEID || '';
      this.ho_cdr_no = this.rowData.HO_CDR_NO || '';
      this.ho_combination_key = this.rowData.HO_COMBINATION_KEY || '';
    }
  }

  deletePayment() {
    this.isSaveClicked = true;
    this.crudLoading = true;

    const clob_settings = [{
      sso_id: this.logged_in_user,
      screen_key: this.globalService?.screen_key || ''
    }];

    const success_message = "Maintenance owner map deleted successfully.";

    this.maintenanceOwnerService.deleteMaintenanceOwner(
      this.GENERAL_CONFIG.base_url,
      this.rowData,
      clob_settings,
      this.logged_in_user,
      this.globalService,
      {} // filterParams - empty for delete operation
    ).pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
      (response: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;

        if (response.errorMessage && response.errorMessage !== 'null') {
          this._snackBar.open(response.errorMessage, 'Close', {
            duration: 4000,
            panelClass: ['error-snackbar']
          });
        } else {
          this._snackBar.open(success_message, 'Close', {
            duration: 4000,
            panelClass: ['success-snackbar']
          });
          this.requestGridUpdate.emit('refresh');
        }
      },
      (error: any) => {
        this.isSaveClicked = false;
        this.crudLoading = false;
        this._snackBar.open('Error occurred while deleting. Please try again.', 'Close', {
          duration: 4000,
          panelClass: ['error-snackbar']
        });
      }
    );
  }

  cancel() {
    this.requestGridUpdate.emit('cancel');
  }
}


